<template>
    <rkm-layout-body title="Lista de convênio médico">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-convenio-medico-create' })"
                color="primary"
                authorize="store-cadastro-convenio-medico"
            >
                Cadastrar convênio médico
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
import List from '@/components/cadastro/convenio-medico/List'

export default {
    components: { List },
}
</script>